import { render } from "./DomainInstructions.vue?vue&type=template&id=67759549&scoped=true"
import script from "./DomainInstructions.vue?vue&type=script&lang=ts"
export * from "./DomainInstructions.vue?vue&type=script&lang=ts"

import "./DomainInstructions.vue?vue&type=style&index=0&id=67759549&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-67759549"

export default script